import { Trans } from '@lingui/macro'
import React from 'react'
import { AttendanceFilter } from '../../types/AttendanceFilter'

export const attendanceStatusOptions: AttendanceFilter[] = [
  { value: 'any', label: <Trans>All</Trans> },
  {
    value: 'invited',
    filter: { fieldName: 'attending', value: null },
    label: <Trans>No response</Trans>
  },
  {
    value: 'attending',
    filter: { fieldName: 'attending', value: true },
    label: <Trans>Accepted</Trans>
  },
  {
    value: 'notAttending',
    filter: { fieldName: 'attending', value: false },
    label: <Trans>Declined</Trans>
  },
  {
    value: 'attended',
    filter: { fieldName: 'present', value: true },
    label: <Trans>Attended</Trans>
  },
  {
    value: 'didNotAttend',
    filter: { fieldName: 'present', value: false },
    label: <Trans>Did not attend</Trans>
  }
]
